import en from './en.json';
import ptBR from './pt-BR.json';
import esMX from './es-MX.json';
import esCO from './es-CO.json';

// Copy for the LATAM site (LATAM English, Brazil, Mexico, Colombia). These are
// written per market in the LATAM Website Copy doc, not translated from the
// US `en.json`, and must keep the same keys (see scripts/check-i18n.js).
const dictionaries = {
  'en-LATAM': en,
  'pt-BR': ptBR,
  'es-MX': esMX,
  'es-CO': esCO,
};

export function getLatamDictionary(locale) {
  return dictionaries[locale];
}
